import moment from 'moment';

export const UNAVAILABLE_TIMES = {
    0: {
        canEditStartTime: false,
        canEditEndTime: false,
        unavailableSlots: [],
    },
    1: {
        canEditStartTime: false,
        canEditEndTime: true,
        unavailableSlots: [
            {
                startTime: moment({ h: 14 }).format(`YYYY-MM-DD HH:mm:ss`),
                endTime: moment({ h: 15 }).format(`YYYY-MM-DD HH:mm:ss`),
                reasons: [
                    `Driver 'Steven Crake' is booked from 2:00 pm to 3:00 pm`,
                ],
            },
        ],
    },
    2: {
        canEditStartTime: true,
        canEditEndTime: true,
        unavailableSlots: [
            {
                startTime: moment(8, `HH`).format(`YYYY-MM-DD HH:mm:ss`),
                endTime: moment(14, `HH`).add(3, `d`).format(`YYYY-MM-DD HH:mm:ss`),
                reasons: [
                    `Plant 'Steven's Car's availability schedule prevents it from being used`,
                ],
            },
            {
                startTime: moment(19, `HH`).format(`YYYY-MM-DD HH:mm:ss`),
                endTime: moment(22, `HH`).add(3, `d`).format(`YYYY-MM-DD HH:mm:ss`),
                reasons: [
                    `Driver 'Leroy Jenkins' is booked from 7:00 pm to 10:00 pm`,
                ],
            },
        ],
    },
    3: {
        canEditStartTime: false,
        canEditEndTime: true,
        unavailableSlots: [
            {
                startTime: moment(15, `HH`).add(1, `d`).format(`YYYY-MM-DD HH:mm:ss`),
                endTime: moment(19, `HH`).add(7, `d`).format(`YYYY-MM-DD HH:mm:ss`),
                reasons: [
                    `Passenger 'Steven Crake' is booked from 3:00 pm to 7:00 pm`,
                    `Passenger 'Kerry Arts' is booked from 5:00 pm to 6:00 pm`,
                ],
            },
        ],
    },
    4: {
        canEditStartTime: true,
        canEditEndTime: true,
        unavailableSlots: [
            {
                startTime: moment(4, `HH`).add(2, `d`).format(`YYYY-MM-DD HH:mm:ss`),
                endTime: moment(8, `HH`).add(2, `d`).format(`YYYY-MM-DD HH:mm:ss`),
                reasons: [
                    `Driver 'Jacob Toye' is booked from 4:00 am to 8:00 am`,
                ],
            },
            {
                startTime: moment(11, `HH`).add(15, `m`).add(2, `d`).format(`YYYY-MM-DD HH:mm:ss`),
                endTime: moment(14, `HH`).add(2, `d`).format(`YYYY-MM-DD HH:mm:ss`),
                reasons: [
                    `Plant 'Jacob's Car' is booked from 11:15 am to 2:00 pm`,
                ],
            },
        ],
    },
    5: {
        canEditStartTime: false,
        canEditEndTime: false,
        unavailableSlots: [],
    },
    6: {
        canEditStartTime: true,
        canEditEndTime: true,
        unavailableSlots: [
            {
                startTime: moment(11, `HH`).add(5, `d`).format(`YYYY-MM-DD HH:mm:ss`),
                endTime: moment(13, `HH`).add(5, `d`).format(`YYYY-MM-DD HH:mm:ss`),
                reasons: [
                    `Plant 'Jacob's Car' is booked from 11:00 am to 1:00 pm`,
                ],
            },
            {
                startTime: moment(11, `HH`).add(21, `d`).format(`YYYY-MM-DD HH:mm:ss`),
                endTime: moment(17, `HH`).add(21, `d`).format(`YYYY-MM-DD HH:mm:ss`),
                reasons: [
                    `Plant 'Jacob's Car' is booked from 11:00 am to 5:00 pm`,
                ],
            },
        ],
    },
    // Some data to cover 'new' bookings created after we boot up
    7: {
        canEditStartTime: true,
        canEditEndTime: true,
        unavailableSlots: [],
    },
    8: {
        canEditStartTime: true,
        canEditEndTime: true,
        unavailableSlots: [],
    },
    9: {
        canEditStartTime: true,
        canEditEndTime: true,
        unavailableSlots: [],
    },
};



// WEBPACK FOOTER //
// ./scripts/constants/fakeData/unavailableTimes.js